import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/rise-up-king/banner-hero.webp";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Banner() {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVideoLoaded(true);
          observer.disconnect(); // Stop observing once the video is loaded
        }
      },
      { threshold: 0.1 } // Adjust the threshold as needed
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (observer && sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section
      className="banner-rise-up text_white"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="mb-4 mb-md-0">
            <div className="logo">
              <StaticImage
                src="../../../images/case-studies/rise-up-king/main-logo.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={116}
                height={176}
              />
            </div>
            <h2>
              <span className="text-rise-yellow">100+</span> Goals Achieved,
              <span className="text-rise-yellow">1,000+</span> Active Users, and
              2 Magnificent Years of Innovation.
            </h2>
            <h4>
              Discover <span className="text-rise-yellow">Rise Up Kings</span>,
              Where Personal Development Meets Community!
            </h4>
            <p>
              With a powerful blend of personal development tools and community
              engagement, Rise Up Kings transforms how users track their goals,
              connect with like-minded individuals, and grow together.
            </p>
            <Link
              to="/contact"
              className="border_btn rise-up-btn"
              aria-label="TekRevol Contact"
            >
              Start Your Journey Today
            </Link>
          </Col>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="offset-lg-1 my-auto"
          >
            {videoLoaded ? (
              <StaticImage
                src="../../../images/case-studies/rise-up-king/banner-img-before.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={692}
                height={747}
              />
            ) : (
              <StaticImage
                src="../../../images/case-studies/rise-up-king/banner-hero-img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={2762}
                height={2987}
              />
            )}
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
